import React from "react";
import SignUpForm from "./SignUpForm";
import {FormattedMessage} from "react-intl";

import './SignUpView.style.scss';

const SignUpView = () => {

    window.scrollTo(0, 0);



    return (
        <div className="SignUpView" id="RegisterPage">
            <div className="SignUpFormSection">
                <div className="leftSide">
                    <div className="leftSideContent">
                        <h1 className="title"><FormattedMessage id={'signUp.joinTradeFan.titleJoin'}/></h1>
                        <h2 className="title2"><FormattedMessage id={'signUp.joinTradeFan.createFreeAccount'}/></h2>
                        <p className="subtitle gold-gradient-text">
                            <FormattedMessage id={'signUp.joinTradeFan.playForFreeWin'}/>
                        </p>
                        <ul className="listOfSteps">
                            <li><FormattedMessage id={'landingPageAlt.easyToPlay.steps.step1.title'}/></li>
                            <li><FormattedMessage id={'landingPageAlt.easyToPlay.steps.step2.title'}/></li>
                            <li><FormattedMessage id={'landingPageAlt.easyToPlay.steps.step3.title'}/></li>
                            <li><FormattedMessage id={'landingPageAlt.easyToPlay.steps.step4.title'}/></li>
                        </ul>
                    </div>
                </div>
                <div className="rightSide">
                    <SignUpForm/>
                </div>
            </div>
        </div>
    );
}

export default SignUpView;